import { ScrollView } from 'react-native';

import { Box, VStack, theme } from '@squire/ui';

import { ChooseTimeCalendarSkeleton } from '@/components/booking/ChooseTimeCalendarSkeleton';
import { ChooseTimeLoadingScreen } from '@/components/booking/ChooseTimeLoadingScreen';

import { styles } from './styles';
import type { ChooseTimeSkeletonProps } from './types';

const ChooseTimeSkeleton = ({
  testID,
  style,
  timeSlotCount,
}: ChooseTimeSkeletonProps) => {
  return (
    <ScrollView
      testID={testID}
      style={[styles.scrollView, style]}
      nestedScrollEnabled
      contentContainerStyle={styles.scrollContent}
      showsVerticalScrollIndicator={false}
    >
      <VStack space={theme.spacing[8]}>
        <Box>
          <ChooseTimeCalendarSkeleton />
        </Box>

        <ChooseTimeLoadingScreen timeSlotCount={timeSlotCount} />
      </VStack>
    </ScrollView>
  );
};

ChooseTimeSkeleton.displayName = 'ChooseTimeSkeleton';

export { ChooseTimeSkeleton };
